import { render, staticRenderFns } from "./archive-form-component.vue.vue?vue&type=template&id=64288c3a&scoped=true"
import script from "./archive-form-component.vue.vue?vue&type=script&lang=js"
export * from "./archive-form-component.vue.vue?vue&type=script&lang=js"
import style0 from "./archive-form-component.vue.vue?vue&type=style&index=0&id=64288c3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64288c3a",
  null
  
)

export default component.exports